// TODO: This is meant to be a temproary list of known
//       SR-series that are commonly made available to users.
//       Long term this should come from the mosaics list.
export const SR_SERIES_IDS = [
  '7613b6f8-6aaf-4a3c-8ffc-ac4520de402e',
  'd7f66ec2-2fc3-4ec0-abc3-00b78a6b9651',
  '19114a0f-a2a3-4079-beb6-32ffa20d8c2b',
  '14270b0c-68d4-4148-b8ea-a436d9949cb2',
  '1f7cc8d5-4461-478b-a945-18cce5e8b516',
  '093816bd-d78b-4cc6-a862-f4bea52c2cd3',
  '93885217-c43a-4b14-a01f-a689dfd714b5',
  '5b537517-72d6-492e-ab1d-62a8bf39613f',
  'd297a16c-3c82-40cc-ac48-e9bba0886089',
  '6657681d-0605-42e8-b3f9-0859f47a4392',
  '6e4d3274-4b56-439b-9b44-9d966a693ac5',
  '9f92a7c0-43b0-4aef-8e98-5b7481a291c0',
  '60290b70-e799-4430-a575-e5dd3ea9d916',
  '63bb03d3-cf2c-45f8-8330-f9ad45272f97',
  '2f123382-9095-424d-96cc-2a30b2019e31',
  'db9e314b-83b6-43eb-88af-fccd61c4a0e2',
  '0999a5cf-e5e5-40c3-aa62-eb84e72e729d',
  '37375a8b-5406-4924-be12-045817dd54e8',
  'b00f31cd-b03c-456f-a670-ee3afe152e39',
  'e412fb5d-cc34-41c9-bf02-4bfe6204aad8',
  '80698bb6-922c-4d4b-ab23-194046690a0f',
  '0697bd65-b869-4f83-b5a2-085343b123df',
  '5f8b7ac5-e8ea-447a-b4a0-8122e3bb712b',
  'bf1098f6-d932-41d1-9a51-b96b5a5391e8',
  '657a170f-71a3-4ff4-bd51-cd0dcd66fd02',
  'e6175029-4041-41e0-b79f-3b1b44c1c6cb',
  '8be97a61-fc42-40ab-b576-13b8bd1f6a66',
  'ad252eef-aa22-44f3-93e3-a8bacfa2c94c',
  '26a42ea3-f3d0-4fdf-b4f0-28688edaf858',
  'f37db713-15b4-42e3-9f7f-d7c8056cefde',
  '80988c3c-30cd-4baf-89b6-bf0728399d1c',
  'd8db1814-8534-4de0-a956-d7ba67deb2d7',
  '3b9ef546-a48b-46ef-9a6a-4e3e8b9c21d7',
  '6da57b12-71e4-4100-92e9-43cd1eeb46e5',
  '3b529215-eea4-475f-97fd-c54f71d014d5',
  '916d2dd8-1cc5-44d1-921d-583b33e96eb4',
  'f3951e35-b9d2-41e0-911b-9039ab5d0419',
  'ec28d356-10d2-48cb-9039-22be5c7a99e3',
  '70143488-e4aa-4742-aec2-eb8978651add',
  '3bdead67-1584-46c1-abc1-8bd159cf2a25',
  'bc1f17d4-7603-4024-8ae7-027beec6d345',
  '00d715b9-947a-4886-a6ec-88dfe1acb05e',
];

export const INTERVALS = {
  BIWEEK: '14 days',
  DAY: '1 day',
  MONTH: '1 mon',
  QUARTER: '3 mons',
  WEEK: '7 days',
};

// opinionated order to show filters
//TODO: daily series cause havoc on the timeline
export const SORTED_SERIES_INTERVALS = [
  INTERVALS.WEEK,
  INTERVALS.BIWEEK,
  INTERVALS.MONTH,
  INTERVALS.QUARTER,
];

export const SORTED_ALL_INTERVALS = [INTERVALS.DAY, ...SORTED_SERIES_INTERVALS];

export const INTERVAL_LABELS = {
  [INTERVALS.QUARTER]: 'Quarterly',
  [INTERVALS.MONTH]: 'Monthly',
  [INTERVALS.WEEK]: 'Weekly',
  [INTERVALS.BIWEEK]: 'Bi-weekly',
  [INTERVALS.DAY]: 'Daily',
};

export const MODES = {
  MOSAICS: 'mosaics',
  QUADS: 'quads',
  SCENES: 'scenes',
};
